import { ExternalLink } from './ExternalLink'
import { ReactNode } from 'react'
import { clsx } from 'clsx'

const ButtonLink = ({
  path,
  children,
  className = '',
  disabled,
}: {
  path: string
  children: ReactNode
  className?: string
  disabled?: boolean
}) => {
  return (
    <ExternalLink
      className={clsx(
        'flex w-max items-center justify-center rounded-full bg-th-button px-5 py-3 font-bold text-th-button-text md:hover:bg-th-button-hover md:hover:text-th-button-text',
        disabled && 'cursor-not-allowed opacity-60',
        className,
      )}
      href={path}
    >
      {children}
    </ExternalLink>
  )
}

export default ButtonLink
